module.exports = __webpack_public_path__ + "Neumocabeza.png?8507a01c74114f95ecd92b964c557077";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Neumocabeza.png
// module id = 943
// module chunks = 0